import React from "react";
import {Container} from "react-bootstrap";
import {headingStyles, regularTextStyles} from "../Style";

const ErrorPage = props => {
    return (
      <Container style={{paddingBottom: "110px"}}>
            <>
                <br/>
                <br/>
                <p style={headingStyles}>Oops!<br/> <span style={regularTextStyles}>An unexpected error occurred. Please try again.</span>

                </p>
                <br/><br/><br/><br/>


            </>
        </Container>
    );
}

export default ErrorPage;
